module.exports = __webpack_public_path__ + "static/cleaneranswer-6b2511b511db6a20245d1e3a7a73bda4.jpg";